import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../types';
import './FeaturedHero.css';

interface FeaturedHeroProps {
  post: BlogPost;
  className?: string;
}

const FeaturedHero: React.FC<FeaturedHeroProps> = ({ post, className = '' }) => {

  return (
    <article className={`featured-hero ${className}`}>
      <div className="featured-hero__container">
        <Link to={`/blog/${post.slug}`} className="featured-hero__link">
          <div className="featured-hero__content">
            <div className="featured-hero__image">
              <img 
                src={post.featuredImage.url} 
                alt={post.featuredImage.alt}
                className="featured-hero__image-img"
              />
            </div>

            <div className="featured-hero__text">
              <span className="category-text">{post.category.name}</span>
              
              <h1 className="featured-hero__title">{post.title}</h1>
              
              <p className="featured-hero__excerpt">{post.excerpt}</p>
            </div>
          </div>
        </Link>
      </div>
    </article>
  );
};

export default FeaturedHero;